import "../types/checkout/ingridApi";

let suspendDepth = 0;

const callWidget = (action: "suspend" | "resume") => {
	if (!import.meta.client || typeof window._sw !== "function") return;
	window._sw((api) => {
		api[action]?.();
	});
};

export const useIngridSuspend = () => {
	const withIngridSuspended = async <T>(
		callback: () => Promise<T>
	): Promise<T> => {
		suspendDepth += 1;
		if (suspendDepth === 1) callWidget("suspend");
		try {
			return await callback();
		} finally {
			suspendDepth = Math.max(0, suspendDepth - 1);
			if (suspendDepth === 0) callWidget("resume");
		}
	};

	return { withIngridSuspended };
};
